const dark = {
  surface: "#FFC451",
  onSurface: "#000000",
  surfaceHover: "#FFD685",
  surfaceDisabled: "#FFEDCB",
  onAccentBorder: "#FFC451",
  surfaceAccent1: "#FFFCF5",
  surfaceAccent2: "#FFE7B9",
  onSurfaceBorder: "#FFD685 ",
  onSurfacePrimary: "#18181B",
};

const light = {
  surface: "#004DC1",
  onSurface: "#FFFFFF",
  surfaceHover: "#002E74",
  surfaceDisabled: "#B3CAEC",
  onAccentBorder: "#99B8E6",
  surfaceAccent1: "#F3F6FC",
  surfaceAccent2: "#CCDBF3",
  onSurfaceBorder: "#D4D4D8",
  onSurfacePrimary: "#18181B",
};

export const colorScheme = {
  light,
  dark,
};
